import React, { memo } from 'react';
import './totalBaselineTable.styles.scss';

const TotalBaselineTable = memo(({
    header,
    data,
    normalRow,
    growthRow,
    cagrRow,
    avgRow,
    headerBg,
    headerFg,
    normalQtrRow,
    growthQtrRow,
    cagrQtrRow,
    totalNormalRow,
    totalGrowthRow,
    totalCAGRRow,
    FlexGrow,
    tableWidth,
    normalAWSRow,
    normalAWSQtrRow,
    totalNormalAWSRow,
    normalDipRow,
    normalDipQtrRow,
    average2YearDipQtrRow,
    average3YearDipQtrRow

}) => {
    return (
        <table className='baseline-table' style={(tableWidth && FlexGrow) ? { flexGrow: FlexGrow, width: tableWidth } : { flexGrow: FlexGrow }}>
            <thead>
                <tr>
                    {
                        header && header.map((item, ind) => (
                            <td key={item.name + ind} className='baseline-table-cell-padding' style={{ backgroundColor: headerBg, color: headerFg }}>{item.name}</td>
                        ))
                    }
                </tr>
            </thead>

            <tbody>

                {
                    // ********* Maps Years Row for Volume Data ************
                    normalRow && data.Data && data.Data.map((item, ind) => (
                        <tr key={'key' + ind}>
                            <th className='baseline-table-cell-padding baseline-table-cell-border header-cell-fg'>{item.Year}</th>
                            {
                                item.yeardata.map((elm, indx) => (
                                    <td className="baseline-table-cell-padding baseline-table-cell-border" key={'key' + indx}>{(elm.Volume)?.toFixed(0)}</td>
                                ))
                            }
                        </tr>
                    ))
                }

                {
                    // ********* Maps Years Row for AWS Data ************
                    normalAWSRow && data.Data && data.Data.map((item, ind) => (
                        <tr key={'key' + ind}>
                            <th className='baseline-table-cell-padding baseline-table-cell-border header-cell-fg'>{item.Year}</th>
                            {
                                item.yeardata.map((elm, indx) => (
                                    <td className="baseline-table-cell-padding baseline-table-cell-border" key={'key' + indx}>{(elm.AwsVolume)?.toFixed(0)}</td>
                                ))
                            }
                        </tr>
                    ))
                }

                {
                    // ********* Maps Years Row for Dip Data ************
                    normalDipRow && data.Data && data.Data.map((item, ind) => (
                        <tr key={'key' + ind}>
                            <th className='baseline-table-cell-padding baseline-table-cell-border header-cell-fg'>{item.Year}</th>
                            {
                                item.yeardata.map((elm, indx) => (
                                    <td className="baseline-table-cell-padding baseline-table-cell-border" key={'key' + indx}
                                        style={elm?.Dip < 0 ? { color: '#ff0919' } : elm?.Dip > 0 ? { color: '#6ea943' } : { color: '#ffb822' }}
                                    >
                                        {elm.Dip ? (elm.Dip)?.toFixed(2) + '%' : null}</td>
                                ))
                            }
                        </tr>
                    ))
                }

                {
                    // ********* Maps Years Growth Row for Volume Data ************
                    growthRow && data.Data && data.Data.map((item, ind) => (
                        <tr key={'key' + ind}>
                            <th className='baseline-table-cell-padding baseline-table-cell-border header-cell-fg'>Growth {item.Year}</th>
                            {
                                item.yeardata.map((elm, indx) => (
                                    <td key={'key' + indx}
                                        className="baseline-table-cell-padding baseline-table-cell-border"
                                        style={elm?.Growth < 0 ? { color: '#ff0919' } : elm?.Growth > 0 ? { color: '#6ea943' } : { color: '#ffb822' }}>
                                        {(elm.Growth) ? (elm.Growth)?.toFixed(2) + '%' : null}
                                    </td>
                                ))
                            }
                        </tr>
                    ))
                }

                {
                    // ********* Maps CAGR null Row for Volume Data ************
                    cagrRow && <tr className='cagr-row-bg'>
                        <th className='baseline-table-cell-padding baseline-table-cell-border header-cell-fg'>CAGR 3 Year</th>
                        {
                            header && header.pop() && header.map((elm, indx) => (
                                <td key={'key' + indx}
                                    className="baseline-table-cell-padding baseline-table-cell-border">
                                    {null}
                                </td>
                            ))
                        }
                    </tr>
                }

                {
                    // ********* Maps Quarters of Year Row for Volume Data ************
                    normalQtrRow && data.Data && data.Data.map((item, ind) => (
                        <tr key={'key' + ind}>
                            <th className='baseline-table-cell-padding baseline-table-cell-border header-cell-fg'>{item.Year}</th>
                            {
                                item.Quarter.map((elm, indx) => (
                                    (Object.keys(elm)[0] === 'Q1' || Object.keys(elm)[0] === 'Q2' || Object.keys(elm)[0] === 'Q3' || Object.keys(elm)[0] === 'Q4') && <td className="baseline-table-cell-padding baseline-table-cell-border" key={'key' + indx}>{(elm[Object.keys(elm)[0]])?.toFixed(0)}</td>
                                ))
                            }
                        </tr>
                    ))
                }

                {
                    // ********* Maps Quarters of Year Row for AWS Data ************
                    normalAWSQtrRow && data.Data && data.Data.map((item, ind) => (
                        <tr key={'key' + ind}>
                            <th className='baseline-table-cell-padding baseline-table-cell-border header-cell-fg'>{item.Year}</th>
                            {
                                item.QuarterAws.map((elm, indx) => (
                                    (Object.keys(elm)[0] === 'Q1' || Object.keys(elm)[0] === 'Q2' || Object.keys(elm)[0] === 'Q3' || Object.keys(elm)[0] === 'Q4') && <td className="baseline-table-cell-padding baseline-table-cell-border" key={'key' + indx}>{(elm[Object.keys(elm)[0]])?.toFixed(0)}</td>
                                ))
                            }
                        </tr>
                    ))
                }

                {
                    // ********* Maps Quarters of Year Row for Dip Data ************
                    normalDipQtrRow && data.Data && data.Data.map((item, ind) => (
                        <tr key={'key' + ind}>
                            <th className='baseline-table-cell-padding baseline-table-cell-border header-cell-fg'>{item.Year}</th>
                            {
                                item.QuarterDip.map((elm, indx) => (
                                    <td className="baseline-table-cell-padding baseline-table-cell-border" key={'key' + indx}
                                        style={(elm[Object.keys(elm)[0]]) < 0 ? { color: '#ff0919' } : (elm[Object.keys(elm)[0]]) > 0 ? { color: '#6ea943' } : { color: '#ffb822' }}
                                    >
                                        {(elm[Object.keys(elm)[0]]) ? (elm[Object.keys(elm)[0]])?.toFixed(2) + '%' : null}
                                    </td>
                                ))
                            }
                        </tr>
                    ))
                }

                {
                    // ********* Maps Average 2 Years Quarter Row for Dip Data ************
                    average2YearDipQtrRow &&
                    <tr>
                        <th className='baseline-table-cell-padding baseline-table-cell-border header-cell-fg'>Average 2 Years</th>
                        {
                            data.Average2YearsQuarter && data.Average2YearsQuarter.map((elm, indx) => (
                                (Object.keys(elm)[0] === 'Q1' || Object.keys(elm)[0] === 'Q2' || Object.keys(elm)[0] === 'Q3' || Object.keys(elm)[0] === 'Q4') && <td className="baseline-table-cell-padding baseline-table-cell-border" key={'key' + indx}
                                    style={(elm[Object.keys(elm)[0]]) < 0 ? { color: '#ff0919' } : (elm[Object.keys(elm)[0]]) > 0 ? { color: '#6ea943' } : { color: '#ffb822' }}>
                                    {(elm[Object.keys(elm)[0]])?.toFixed(2)}
                                </td>

                            ))
                        }
                    </tr>
                }

                {
                    // ********* Maps Average 3 Years Quarter Row for Dip Data ************
                    average3YearDipQtrRow &&
                    <tr>
                        <th className='baseline-table-cell-padding baseline-table-cell-border header-cell-fg'>Average 3 Years</th>
                        {
                            data.Average3YearsQuarter && data.Average3YearsQuarter.map((elm, indx) => (
                                (Object.keys(elm)[0] === 'Q1' || Object.keys(elm)[0] === 'Q2' || Object.keys(elm)[0] === 'Q3' || Object.keys(elm)[0] === 'Q4') && <td className="baseline-table-cell-padding baseline-table-cell-border" key={'key' + indx}
                                    style={(elm[Object.keys(elm)[0]]) < 0 ? { color: '#ff0919' } : (elm[Object.keys(elm)[0]]) > 0 ? { color: '#6ea943' } : { color: '#ffb822' }}>
                                    {(elm[Object.keys(elm)[0]])?.toFixed(2)}
                                </td>

                            ))
                        }
                    </tr>
                }

                {
                    // ********* Maps Quarters of Year Growth Row for Volume Data ************
                    growthQtrRow && data.Data && data.Data.map((item, ind) => (
                        <tr key={'key' + ind}>
                            <th className='baseline-table-cell-padding baseline-table-cell-border header-cell-fg'>Growth {item.Year}</th>
                            {
                                item.Quarter.map((elm, indx) => (
                                    (Object.keys(elm)[0] === 'GrowthQ1' || Object.keys(elm)[0] === 'GrowthQ2' || Object.keys(elm)[0] === 'GrowthQ3' || Object.keys(elm)[0] === 'GrowthQ4') &&
                                    <td style={(elm[Object.keys(elm)[0]]) < 0 ? { color: '#ff0919' } : (elm[Object.keys(elm)[0]]) > 0 ? { color: '#6ea943' } : { color: '#ffb822' }} className="baseline-table-cell-padding baseline-table-cell-border" key={'key' + indx}>
                                        {(elm[Object.keys(elm)[0]]) ? (elm[Object.keys(elm)[0]])?.toFixed(2) + '%' : null}
                                    </td>
                                ))
                            }
                        </tr>
                    ))
                }

                {
                    // ********* Maps Quarters of Year CAGR Row for Volume Data ************
                    cagrQtrRow && <tr className='cagr-row-bg'>
                        <th className='baseline-table-cell-padding baseline-table-cell-border header-cell-fg'>CAGR 3 Year</th>
                        {
                            data.CAGR && data.CAGR.map((elm, indx) => (
                                (Object.keys(elm)[0] === 'Q1' || Object.keys(elm)[0] === 'Q2' || Object.keys(elm)[0] === 'Q3' || Object.keys(elm)[0] === 'Q4') &&
                                <td style={(elm[Object.keys(elm)[0]]) < 0 ? { color: '#ff0919' } : (elm[Object.keys(elm)[0]]) > 0 ? { color: '#6ea943' } : { color: '#ffb822' }} className="baseline-table-cell-padding baseline-table-cell-border" key={'key' + indx}>{(elm[Object.keys(elm)[0]])?.toFixed(2)}</td>
                            ))
                        }
                    </tr>
                }

                {
                    // ********* Maps Total Rows of Year for Volume Data ************
                    totalNormalRow && data.Data && data.Data.map((item, ind) => (
                        <tr key={'key' + ind} className='cagr-row-bg'>
                            {
                                item.Quarter.map((elm, indx) => (
                                    (Object.keys(elm)[0] === 'Total') &&
                                    <th className="baseline-table-cell-padding baseline-table-cell-border" key={'key' + indx}>
                                        {(elm[Object.keys(elm)[0]])?.toFixed(0)}
                                    </th>
                                ))
                            }
                        </tr>
                    ))
                }

                {
                    // ********* Maps Total Rows of Year for AWS Data ************
                    totalNormalAWSRow && data.Data && data.Data.map((item, ind) => (
                        <tr key={'key' + ind} className='cagr-row-bg'>
                            {
                                item.QuarterAws.map((elm, indx) => (
                                    (Object.keys(elm)[0] === 'Total') &&
                                    <th className="baseline-table-cell-padding baseline-table-cell-border" key={'key' + indx}>
                                        {(elm[Object.keys(elm)[0]])?.toFixed(0)}
                                    </th>
                                ))
                            }
                        </tr>
                    ))
                }

                {
                    // ********* Maps Growth Total Rows of Year for Volume Data ************
                    totalGrowthRow && data.Data && data.Data.map((item, ind) => (
                        <tr key={'key' + ind} className='cagr-row-bg'>
                            {
                                item.Quarter.map((elm, indx) => (
                                    (Object.keys(elm)[0] === 'TotalGrowth') &&
                                    <th style={(elm[Object.keys(elm)[0]]) < 0 ? { color: '#ff0919' } : (elm[Object.keys(elm)[0]]) > 0 ? { color: '#6ea943' } : { color: '#ffb822' }} className="baseline-table-cell-padding baseline-table-cell-border" key={'key' + indx}>
                                        {(elm[Object.keys(elm)[0]]) ? (elm[Object.keys(elm)[0]])?.toFixed(2) + '%' : <span style={{ color: 'transparent' }}>0</span>}
                                    </th>
                                ))
                            }
                        </tr>
                    ))
                }

                {
                    // ********* Maps CAGR Total Row for Volume Data ************
                    totalCAGRRow && <tr className='cagr-row-bg'>
                        {
                            data.CAGR && data.CAGR.map((elm, indx) => (
                                (Object.keys(elm)[0] === 'Total') &&
                                <th style={(elm[Object.keys(elm)[0]]) < 0 ? { color: '#ff0919' } : (elm[Object.keys(elm)[0]]) > 0 ? { color: '#6ea943' } : { color: '#ffb822' }}
                                    className="baseline-table-cell-padding baseline-table-cell-border" key={'key' + indx}
                                >
                                    {(elm[Object.keys(elm)[0]]) ? (elm[Object.keys(elm)[0]])?.toFixed(2) + '%' : null}
                                </th>
                            ))
                        }
                    </tr>
                }

                {
                    // ********* Maps 'Average 2 Years' Row for Dip Data ************
                    avgRow && <tr>
                        <th className='baseline-table-cell-padding baseline-table-cell-border header-cell-fg'>Average 2 Years</th>
                        {
                            data.Average2Years && data.Average2Years.map((elm, indx) => (
                                <td className="baseline-table-cell-padding baseline-table-cell-border" key={'key' + indx}
                                    style={elm?.Average < 0 ? { color: '#ff0919' } : elm?.Average > 0 ? { color: '#6ea943' } : { color: '#ffb822' }}
                                >
                                    {elm.Average ? (elm.Average)?.toFixed(2) + '%' : null}</td>
                            ))
                        }
                    </tr>
                }

                {
                    // ********* Maps 'Average 3 Years' Row for Dip Data ************
                    avgRow && <tr>
                        <th className='baseline-table-cell-padding baseline-table-cell-border header-cell-fg'>Average 3 Years</th>
                        {
                            data.Average3Years && data.Average3Years.map((elm, indx) => (
                                <td className="baseline-table-cell-padding baseline-table-cell-border" key={'key' + indx}
                                    style={elm?.Average < 0 ? { color: '#ff0919' } : elm?.Average > 0 ? { color: '#6ea943' } : { color: '#ffb822' }}
                                >
                                    {elm.Average ? (elm.Average)?.toFixed(2) + '%' : null}</td>
                            ))
                        }
                    </tr>
                }

            </tbody>

        </table>
    );
})

export default TotalBaselineTable;